var _title, _desc, _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgGarbage = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Garbage")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Garbage")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0.0%",
    y: "0.0%",
    width: "100.0%",
    height: "100.0%",
    filterUnits: "objectBoundingBox",
    id: "garbage-filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowOffsetOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowOffsetOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowOffsetOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M11.25,0 C12.2841667,0 13.125,0.840833333 13.125,1.875 L13.125,2.5 L18.125,2.5 C18.47,2.5 18.75,2.78 18.75,3.125 C18.75,3.47 18.47,3.75 18.125,3.75 L16.825,3.75 L15.7183333,17.0308333 C15.6383333,17.995 14.8175,18.75 13.85,18.75 L4.90083333,18.75 C3.93333333,18.75 3.1125,17.995 3.0325,17.03 L1.925,3.75 L0.625,3.75 C0.28,3.75 0,3.47 0,3.125 C0,2.78 0.28,2.5 0.625,2.5 L5.625,2.5 L5.625,1.875 C5.625,0.840833333 6.46583333,0 7.5,0 L11.25,0 Z M15.5708333,3.75 L3.17916671,3.75 L4.27750004,16.9266667 C4.30416671,17.2483333 4.57750004,17.5 4.90083337,17.5 L13.85,17.5 C14.1725,17.5 14.4466666,17.2483333 14.4725,16.9266667 L15.5708333,3.75 Z M7.5,6.875 C7.845,6.875 8.125,7.155 8.125,7.5 L8.125,13.75 C8.125,14.095 7.845,14.375 7.5,14.375 C7.155,14.375 6.875,14.095 6.875,13.75 L6.875,7.5 C6.875,7.155 7.155,6.875 7.5,6.875 Z M11.25,6.875 C11.595,6.875 11.875,7.155 11.875,7.5 L11.875,13.75 C11.875,14.095 11.595,14.375 11.25,14.375 C10.905,14.375 10.625,14.095 10.625,13.75 L10.625,7.5 C10.625,7.155 10.905,6.875 11.25,6.875 Z M11.25,1.25 L7.5,1.25 C7.155,1.25 6.875,1.53 6.875,1.875 L6.875,2.5 L11.875,2.5 L11.875,1.875 C11.875,1.53 11.595,1.25 11.25,1.25 Z",
    id: "garbage-path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-136.000000, -643.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(112.000000, 625.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#garbage-filter-1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "gargage-mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#garbage-path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "garbage-Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#garbage-path-2"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#gargage-mask-3)",
    fill: "#5A5A5A"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "garbage-Shape",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  })))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGarbage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/garbage.99595221.svg";
export { ForwardRef as ReactComponent };